
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[postId]",
      function () {
        return require("private-next-pages/posts/[postId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[postId]"])
      });
    }
  